import { SearchOutlined } from "@ant-design/icons";
import {
	Card,
	Col,
	Input,
	Pagination,
	Row,
	Select,
	Spin,
	Tag
} from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import getTotalProduct from "../../api/getAllApis/getTotalProduct";
import { loadProduct } from "../../redux/actions/product/getAllProductAction";
import { loadPosProduct } from "../../redux/actions/product/getPosProductAction";
import { loadSingleProductCategory } from "../../redux/actions/productCategory/detailProductCategoryAction";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";
import { debounce } from "../../utils/debounce";
import "./pos.css";

export default function ProductsForSale({ handleSelectedProds }) {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.products.list);
  const category = useSelector((state) => state.productCategories?.list);
  const [loading, setLoading] = useState(false);

  const [finalCat, setFinalCat] = useState([]);

  useEffect(() => {
    const categoryToGetAllProd = {
      id: 0,
      name: "all products",
    };
    if (category !== null) {
      setFinalCat([categoryToGetAllProd, ...category]);
    }
  }, [category]);

  const categoryProd = useSelector(
    (state) => state.productCategories?.category?.product
  );
  const [totalProd, setTotalProd] = useState(0);
  const [prodList, setProdList] = useState(null);

  useEffect(() => {
    dispatch(loadProduct({ status: "true", page: 1, limit: 50 }));
    dispatch(loadAllProductCategory({ page: 1, limit: 100 }));
  }, []);

  useEffect(() => {
    setProdList(list);
  }, [list]);

  //TODO :IMPLEMENT TOTAL PROD info
  useEffect(() => {
    getTotalProduct().then((res) => setTotalProd(res));
  }, [list]);

  const handleCatChange = (catId) => {
    if (catId === 0) {
      dispatch(loadAllProductCategory({ page: 1, limit: 100 }));
      setProdList(list);
    } else {
      dispatch(loadSingleProductCategory(catId));
      setProdList(null);
    }
  };

  const [status, setStatus] = useState("true");

  const onShowSizeChange = (current, pageSize) => {};

  const Products = ({ item, index }) => {
    return (
      <Col span={24} sm={12} xl={8} key={index}>
        <Card
          hoverable
          className="pos-product-card"
          onClick={() => handleSelectedProds(item)}
        >
          <div className="pos-product-card-inner">
            <div className="pos-product-card-image">
              <img alt={item.name} src={item.imageUrl} />
            </div>
            <div className="pos-product-card-content">
              <p className="pos-product-card-title">{item.name}</p>
              <p className="pos-product-card-meta">Sale Price : {item.sale_price}</p>
              <p className="pos-product-card-meta">Stock : {item.quantity}</p>
            </div>
          </div>
          <div className="pos-product-card-sku">
            <Tag>SKU : {item.sku}</Tag>
          </div>
        </Card>
      </Col>
    );
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (searchTerm) => {
      if (searchTerm && searchTerm.trim()) {
        setLoading(true);
        const resp = await dispatch(loadPosProduct(searchTerm.trim()));
        if (resp && resp.status === "success") {
          setProdList(resp.data);
        }
        setLoading(false);
      } else {
        setProdList(list);
      }
    }, 400),
    [dispatch, list]
  );

  const handleSearchChange = (e) => {
    debouncedSearch(e.target.value);
  };

  return (
    <div className="pos-products-for-sale">
      <div className="pos-products-header">
        <div className="pos-search-bar-wrap">
          <Input
            prefix={<SearchOutlined className="pos-search-icon" />}
            placeholder="Search by title, author, ISBN, or publisher..."
            allowClear
            onChange={handleSearchChange}
            className="pos-search-input"
            size="large"
          />
        </div>
        <Select
          className="pos-category-select"
          loading={!category}
          showSearch
          onChange={handleCatChange}
          placeholder="Select Category"
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children ?? "").toString().toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.children ?? "")
              .toString()
              .toLowerCase()
              .localeCompare((optionB?.children ?? "").toString().toLowerCase())
          }
        >
          {finalCat &&
            finalCat.map((cate) => (
              <Select.Option key={cate.id} value={cate.id}>
                {cate.name}
              </Select.Option>
            ))}
        </Select>
      </div>
      <div className="pos-product-list-scroll">
        <Row className="mt-2" gutter={[20, 20]}>
          {prodList ? (
            prodList.map((item, index) => (
              <Products key={index} index={index} item={item} />
            ))
          ) : categoryProd ? (
            categoryProd.map((item, index) => (
              <Products key={index} index={index} item={item} />
            ))
          ) : (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <Spin size="large" />
            </div>
          )}
        </Row>
        {totalProd > 0 && (
          <div className="mt-2">
            <Pagination
              showSizeChanger
              onChange={(page, pageSize) => {
                dispatch(loadProduct({ page, limit: pageSize, status }));
              }}
              onShowSizeChange={onShowSizeChange}
              defaultCurrent={1}
              total={totalProd}
            />
          </div>
        )}
      </div>
    </div>
  );
}
